var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _c(
      "button",
      {
        staticClass:
          "date-navigation__button gds-button gds-button-outline gds-compact",
        attrs: { disabled: _vm.disabled },
        on: {
          click: function($event) {
            return _vm.goBack()
          }
        }
      },
      [
        _c("svg", { staticClass: "gds-icon black shift-left" }, [
          _c("use", {
            attrs: {
              "xlink:href":
                "/wp-content/themes/gmptwentynineteen/assets/symbol-defs.svg#gds-icon-chevron-left"
            }
          })
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }